import {
  AdvancedFiltersComponentModule,
  AdvancedFiltersModel,
  AdvancedFiltersService,
  AdvancedFiltersServiceModule,
} from '@b2b/common/components/advanced-filters';
import { NoticesComponentModule } from '@b2b/common/components/notices';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ThemesData } from '@b2b/common/resolvers';
import { ContentHeaderService, ContentHeaderServiceModule } from '@b2b/common/services/contentHeader';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEListResponse, ACMEResponse, ColumnDef, TODO } from '@b2b/types/core';
import { Customer } from '@b2b/types/customer';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IPromise, IQService, IScope, ITimeoutService } from 'angular';
import { CustomersIndividualsModalsMergeComponentModule } from '../../../modals/merge/components/customers-individuals-modals-merge.component';
import { MergeCustomersModalService } from '../../../modals/merge/services/merge-customers-modal.service';
import {
  CustomersIndividualsListService,
  CustomersIndividualsListServiceModule,
} from '../services/customers-individuals-list.service';

CustomersIndividualsListController.$inject = [
  '$scope',
  '$q',
  '$filter',
  '$state',
  '$timeout',
  'ThemesData',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'PermissionsService',
  'GridDefinitionFactory',
  'GridStateFactory',
  'NoticeFactory',
  'SidebarService',
  'AdvancedFiltersService',
  'CustomersIndividualsListService',
  'MergeCustomersModalService',
  'ContentHeaderService',
  'ThemesHelperService',
];

function CustomersIndividualsListController(
  $scope: IScope & { customersIndividualsList: TODO; customersIndividuals: TODO },
  $q: IQService,
  $filter: IFilterService,
  $state: StateService,
  $timeout: ITimeoutService,
  ThemesData: { data: ACMEResponse<ThemesData> },
  ApiService: TODO,
  CalendarService: TODO,
  HelpersService: TODO,
  PermissionsService: PermissionsService,
  GridDefinitionFactory: TODO,
  GridStateFactory: TODO,
  NoticeFactory: NoticeFactory,
  sidebarService: SidebarService,
  advancedFiltersService: AdvancedFiltersService,
  customersIndividualsListService: CustomersIndividualsListService,
  mergeCustomersModalService: MergeCustomersModalService,
  contentHeaderService: ContentHeaderService,
  themesHelperService: ThemesHelperService
) {
  const ctrl = {
    model: [] as Customer[],
    filtered: [] as Customer[],
    selectedCustomers: [] as Customer[],
    searchQuery: '',
    loadingCustomerDetailsToMerge: false,
    enableCustomerMerge: false,
    get snapshot() {
      return customersIndividualsListService.getSnapshot();
    },
    get loading() {
      return customersIndividualsListService.getSnapshot().hasTag('loading');
    },
    get isSelectingDuplicates() {
      return customersIndividualsListService.getSnapshot().matches({ idle: 'selecting_duplicates' });
    },
    notice: new NoticeFactory(),
    queryTimer: false as IPromise<void> | false,
    orderId: '',
    viewId: '',
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    customersIndividualsListGridName: $state.current.name + '.grid0',
    maxSelectedCustomers: 5,
    canSelectRow: (options: { row: TODO; selectedRows: TODO[] }) => {
      if (ctrl.isSelectingDuplicates) {
        return options.selectedRows.length < ctrl.maxSelectedCustomers;
      }

      return options.selectedRows.length < 1;
    },
    optionsOverride: {
      rowHeight: 40,
      noUnselect: false,
      multiSelect: false,
      canSelectRow: (options: { row: TODO; selectedRows: TODO[] }) => {
        return ctrl.canSelectRow(options);
      },
      data: 'customersIndividualsList.filtered',
      appScopeProvider: {
        onDataGridSelectionChange: function (row: TODO, selectedRows: TODO[]) {
          ctrl.selectedCustomers = selectedRows.slice();
        },
        onDataGridSelectionChanged: (selectedRows: TODO[]) => {
          ctrl.selectedCustomers = selectedRows.slice();
        },
        onDataGridPaginate: (newPage, pageSize, sortField, sortDirection) => {
          ctrl.onDataGridPaginate(newPage, pageSize, sortField, sortDirection);
        },
        onDataGridSortChange: (grid, columns, page) => {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: (item) => {
          ctrl.onDblClick(item);
        },
        onEditClick: (item) => {
          ctrl.onEditClick(item);
        },
        createOrder: (item) => {
          ctrl.createOrder(item);
        },
      },
      initialGridState: {
        sortField: 'customerId',
      },
      columnDefs: [
        {
          field: 'view',
          headerName: 'View',
          width: 50,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.onDblClick(row);
          },
          cellTemplate:
            '<div class="clickable ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.onDblClick(row)" role="link">View<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
          visible: true,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'customerId',
          headerName: 'Acme Customer Number',
          headerTooltip: true,
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'prefix',
          headerName: 'Title',
          headerTooltip: true,
          visible: false,
          enableSorting: false,
        },
        {
          field: 'firstName',
          headerName: 'First Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'middleName',
          headerName: 'Middle Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'lastName',
          headerName: 'Last Name',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'suffix',
          headerName: 'Suffix',
          headerTooltip: true,
          visible: false,
          enableHiding: false,
          enableSorting: false,
        },
        {
          field: 'email',
          headerName: 'Email',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'phoneNumber',
          headerName: 'Phone Number',
          headerTooltip: true,
          visible: true,
        },
        {
          field: 'orgName',
          headerName: 'Org. Name',
          headerTooltip: true,
          visible: false,
        },
        {
          field: 'customerSource',
          headerName: 'Customer Source',
          headerTooltip: true,
          visible: true,
          enableSorting: false,
        },
        {
          field: 'externalCustomerImportId',
          headerName: 'Customer Import Id',
          headerTooltip: true,
          visible: false,
          enableSorting: false,
        },
      ] as ColumnDef[],
    },

    advancedFiltersFields: [
      {
        type: 'section',
        label: 'Search by any combination of these fields:',
      },
      {
        type: 'field',
        ndx: 0,
        label: 'First Name',
        format: 'Text',
        value: 'firstName',
      },
      {
        type: 'field',
        ndx: 1,
        label: 'Last Name',
        format: 'Text',
        value: 'lastName',
      },
      {
        type: 'field',
        ndx: 2,
        label: 'Address',
        format: 'Text',
        value: 'address',
      },
      {
        type: 'field',
        ndx: 3,
        label: 'ZIP',
        format: 'Text',
        value: 'zip',
      },
      {
        type: 'field',
        ndx: 4,
        label: 'Email',
        format: 'Text',
        value: 'email',
      },
      {
        type: 'section',
        label: 'Or search by one of the following:',
      },
      {
        type: 'field',
        ndx: 5,
        label: 'ID',
        format: 'Text',
        value: 'customerId',
      },
    ],
    paramsCustomFields: {
      operator: 'and',
      fields: [],
    } as Pick<AdvancedFiltersModel, 'operator' | 'fields'>,

    init() {
      if (ThemesData && ThemesData.data.success) {
        themesHelperService.setModel(ThemesData.data.payload);
        ctrl.enableCustomerMerge = (themesHelperService.getCompany('enableCustomerMerge') as TODO) ?? false;
      }

      ctrl.updateHeaderState();

      ctrl.orderId = $state.params.orderId;
      ctrl.viewId = $state.current.name ?? '';

      if (PermissionsService.check(['CUSTOMERS_UPDATE'])) {
        const viewColumnIndex = ctrl.optionsOverride.columnDefs.findIndex((columnDef) => columnDef.field === 'view');
        const editColumnIndex = viewColumnIndex + 1;

        ctrl.optionsOverride.columnDefs.splice(editColumnIndex, 0, {
          field: 'edit',
          headerName: 'Edit',
          width: 60,
          onCellNavClick: (row, col) => {
            ctrl.optionsOverride.appScopeProvider.onEditClick(row);
          },
          cellTemplate: `<div class="ui-grid-cell-contents"><a data-ng-click="grid.appScope.onEditClick(row)" role="link">Edit<span class="sr-only"> Customer</span></a></div>`,
          enableHiding: false,
          enableSorting: false,
        });
      }

      /**
       * // TODO: Temporarily hiding the "Create Order" column until we support this workflow through the cart
       * @link https://acmeticketing.atlassian.net/browse/ENG-14445
       */
      // if (PermissionsService.check(['CUSTOMERS_CREATE_ORDER', 'CUSTOMERS_CREATE_ORGANIZATION_ORDER'])) {
      //   ctrl.optionsOverride.columnDefs.push({
      //     field: 'order',
      //     headerName: 'Order',
      //     headerTooltip: true,
      //     width: 40,
      //     cellClass: 'customers-individuals-list-grid-cell',
      //     onCellNavClick: (row, col) => {
      //       ctrl.optionsOverride.appScopeProvider.createOrder(row.entity);
      //     },
      //     cellTemplate:
      //       '<div class="ui-grid-cell-text" data-ng-class="col.colIndex()">' +
      //       '<a title="Create Order" class="programs-list-link programs-list-manual-entry" data-ng-click="grid.appScope.createOrder(row.entity)">' +
      //       '<span class="fa fa-ticket" role="presentation"></span>' +
      //       '</a>' +
      //       '</div>',
      //     visible: true,
      //     enableHiding: false,
      //     suppressSizeToFit: true,
      //     enableSorting: false,
      //   });
      // }

      ctrl.gridDefinition.init(
        ctrl.customersIndividualsListGridName,
        ctrl.optionsOverride,
        ctrl.viewId,
        $state.current.data.enablePreferences
      );

      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData);
    },

    initData() {
      const props = ctrl.gridDefinition.getGridState();
      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);

      ctrl.getCustomers();
    },

    fetchCustomers(): IPromise<{ data: ACMEListResponse<Customer> }> {
      const props = Object.assign({}, ctrl.gridState.getGridState());

      if (ctrl.snapshot.context.searchMode === 'advancedSearch') {
        return ApiService.customers.advancedSearch(props);
      }

      return ApiService.customers.list(props);
    },

    getCustomers() {
      customersIndividualsListService.fetchCustomers();
      ctrl.gridDefinition.isLoaded = !ctrl.loading;

      ctrl.notice.hideMessages();

      return ctrl
        .fetchCustomers()
        .then((response) => {
          ctrl.filtered = ctrl.process(response.data.payload.list);

          $timeout(() => {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: ctrl.gridDefinition.options.gridName,
              datasetLength: ctrl.filtered.length,
              totalItems: response.data.payload.pagination.count,
            });
          }, 10);

          customersIndividualsListService.fetchCustomersSuccess();

          if (ctrl.snapshot.matches('idle') && sidebarService.isShown) {
            sidebarService.hide();
          }
        })
        .catch((response) => {
          customersIndividualsListService.fetchCustomersFailed();
          ctrl.notice.showErrorMessages([{ message: response.data.error }]);
        })
        .finally(() => {
          ctrl.gridDefinition.isLoaded = !ctrl.loading;
          ctrl.updateRowSelectionMode();
        });
    },

    createOrder(customer) {
      // TODO: extract this logic to a reusable service
      // Call parent controller for this
      $scope.customersIndividuals.createOrder(customer);
    },

    onFilterbarSubmit(props: { model: string }) {
      ctrl.searchQuery = props.model;
      ctrl.query();
    },

    onAdvancedFiltersInit() {
      if (ctrl.snapshot.context.searchMode === 'advancedSearch') {
        advancedFiltersService.updateFromRawFilters({
          name: 'customersIndividualsList',
          filters: ctrl.snapshot.context.rawFilters,
        });
      }
    },

    onAdvancedFiltersClear() {
      ctrl.paramsCustomFields.fields = [];
      ctrl.paramsCustomFields.operator = 'and';

      // Always use basic search when clearing advanced filters
      ctrl.query();
    },

    onAdvancedFiltersSubmit(props: AdvancedFiltersModel) {
      // Clears basic search
      ctrl.searchQuery = '';

      ctrl.paramsCustomFields.fields = props.fields;
      ctrl.paramsCustomFields.operator = props.operator;

      ctrl.queryWithAdvancedSearch(props);
    },

    onAdvancedFiltersClose() {
      sidebarService.hide();
    },

    updateHeaderState() {
      if (ctrl.loading) {
        return;
      }

      contentHeaderService.update({
        title: 'Customers',
        buttonRight: ctrl.enableCustomerMerge
          ? {
              permissions: ['CUSTOMERS_MERGE'],
              label: ctrl.isSelectingDuplicates ? 'Cancel Merge' : 'Merge Duplicates',
              action: () => {
                ctrl.toggleMode();
                ctrl.updateHeaderState();
              },
            }
          : undefined,
      });
    },

    updateRowSelectionMode() {
      if (ctrl.isSelectingDuplicates) {
        ctrl.gridDefinition.setRowSelectionMode('multiple');
      } else {
        ctrl.gridDefinition.setRowSelectionMode('single');
      }
    },

    toggleMode() {
      customersIndividualsListService.toggleMode();
      ctrl.updateRowSelectionMode();
    },

    query() {
      // Clear advanced filters params
      advancedFiltersService.clearAllComponentFilters({ name: 'customersIndividualsList', emitEvent: false });

      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);
      customersIndividualsListService.setBasicSearchState(ctrl.searchQuery);

      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }

      ctrl.queryTimer = $timeout(() => {
        $scope.$broadcast('DataGrid::Search', { name: ctrl.customersIndividualsListGridName });
      }, 300);
    },

    queryWithAdvancedSearch(props: AdvancedFiltersModel) {
      // Reset basic search properties
      ctrl.searchQuery = '';
      ctrl.gridState.setPropertyValue('search', ctrl.searchQuery);

      const validAdvancedFilters = ['firstName', 'lastName', 'address', 'zip', 'email', 'customerId'];

      const filters = props.fields.reduce((filtersMap, field) => {
        filtersMap[field.name] = field.values.join(',');

        return filtersMap;
      }, {});

      validAdvancedFilters.forEach((key) => {
        const value = filters[key] || '';
        ctrl.gridState.setPropertyValue(key, value);
      });

      customersIndividualsListService.setAdvancedSearchState(props.rawFilters);

      ctrl.getCustomers();
    },

    process(members) {
      const formatSortDate = (value) => {
        return $filter('date')(CalendarService.parseDate(value), HelpersService.dateFormats.sortDate);
      };

      members = Array.isArray(members) ? members : [];

      for (let i = 0, ii = members.length; i < ii; i++) {
        members[i].membershipJoinedDateDisplay = formatSortDate(members[i].membershipJoinedDate);
        members[i].membershipExpirationDateDisplay = formatSortDate(members[i].membershipExpirationDate);
      }

      return members;
    },

    mergeCustomers() {
      if (ctrl.loadingCustomerDetailsToMerge) {
        return;
      }

      ctrl.loadingCustomerDetailsToMerge = true;
      const customersPromises = ctrl.selectedCustomers.map((customer) => {
        return mergeCustomersModalService.fetchCustomerDetails(customer.id).then((response) => response.payload);
      });

      return $q
        .all(customersPromises)
        .finally(() => {
          ctrl.loadingCustomerDetailsToMerge = false;
          ctrl.notice.showErrorMessages([{ message: 'Failed to load membership details.' }], { duration: 3000 });
        })
        .then((customersDetails) => {
          return mergeCustomersModalService.open({ customersDetails }).result;
        })
        .then((customer) => {
          $state.go('application.customers.individuals.detail', { id: customer.id });
        });
    },

    onDataGridSortChange(grid, columns, page) {
      const data = columns[0];

      if (data) {
        ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
        ctrl.getCustomers();
      }
    },

    onDblClick(item) {
      // Create and edit are handled by the same controller
      $state.go('application.customers.individuals.detail', { id: item.entity.id });
    },

    onEditClick(item) {
      $state.go('application.customers.individuals.edit', { id: item.entity.id });
    },

    onDataGridPaginate(newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize, sortField, sortDirection);
      ctrl.getCustomers();
    },

    onDestroy() {
      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }
    },
  };

  $scope.customersIndividualsList = ctrl;
  ctrl.init();
}

export const CustomersIndividualsListControllerModule = angular
  .module('acme.view.application.customers.individuals.list.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.themesHelper',
    ContentHeaderServiceModule,
    SidebarServiceModule,
    AdvancedFiltersServiceModule,
    CustomersIndividualsListServiceModule,
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.factory.notice',
    'acme.common.directive.permit',
    AdvancedFiltersComponentModule,
    'acme.common.component.filterbar',
    NoticesComponentModule,
    CustomersIndividualsModalsMergeComponentModule,
  ])
  .controller('CustomersIndividualsListController', CustomersIndividualsListController).name;
